module.exports = __webpack_public_path__ + "static/media/10.27d67d55.png";


//////////////////
// WEBPACK FOOTER
// ./src/sass/images/landpage/10.png
// module id = 296
// module chunks = 0